import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { genericCompareFn } from 'src/app/utils/utils';
import {
  AGENT_HANDOFF_MODES,
  AGENT_HANDOFF_MODE_LABELS,
  AgentHandoffMode,
  INTAKE_MODES,
  INTAKE_MODE_LABELS,
  IntakeMode,
  IntakeSettings,
} from 'src/models/channels';

@Component({
  selector: 'app-intake-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './intake-settings.component.html',
  styleUrls: ['./intake-settings.component.scss'],
})
export class IntakeSettingsComponent implements OnInit {
  @Input() config: IntakeSettings = {
    bot: {
      enabled: false,
      maxResponses: null,
      handoffMode: AGENT_HANDOFF_MODES.PROMPT,
    },
    form: {
      enabled: false,
    },
  };
  @Output() didConfigChange = new EventEmitter<IntakeSettings>();

  intakeModeInput: IntakeMode = INTAKE_MODES.IMMEDIATE;
  botMaxResponsesInput: string = '';
  botHandoffModeInput: AgentHandoffMode = AGENT_HANDOFF_MODES.PROMPT;

  INTAKE_MODES = INTAKE_MODES;
  INTAKE_MODE_LABELS = INTAKE_MODE_LABELS;

  AGENT_HANDOFF_MODES = AGENT_HANDOFF_MODES;
  AGENT_HANDOFF_MODE_LABELS = AGENT_HANDOFF_MODE_LABELS;

  ngOnInit() {
    this.intakeModeInput = this.config?.form?.enabled
      ? INTAKE_MODES.FORM
      : this.config?.bot?.enabled
        ? INTAKE_MODES.BOT_TRIAGE
        : INTAKE_MODES.IMMEDIATE;
    this.botMaxResponsesInput = this.config?.bot?.maxResponses != null ? this.config.bot.maxResponses.toString() : '';
    this.botHandoffModeInput = this.config?.bot?.handoffMode;
  }

  configChanged() {
    this.config = {
      ...this.config,
      form: {
        enabled: this.intakeModeInput === INTAKE_MODES.FORM,
      },
      bot: {
        enabled: this.intakeModeInput === INTAKE_MODES.BOT_TRIAGE,
        maxResponses: this.botMaxResponsesInput ? parseInt(this.botMaxResponsesInput, 10) : null,
        handoffMode: this.botHandoffModeInput,
      },
    };

    this.didConfigChange.emit(this.config);
  }

  updateMaxResponses() {
    const value = String(this.botMaxResponsesInput).trim();
    this.config.bot.maxResponses = value ? parseInt(value, 10) : null;
    this.configChanged();
  }

  genericCompareFn(v1, v2) {
    return genericCompareFn(v1, v2);
  }
}
